import { useAutocompleteSource } from '@eas/common-web';
import { DictBarcodePrinterAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useBarcodePrinters() {
  return useAutocompleteSource<DictBarcodePrinterAutocomplete>({
    url: `${EvidenceApiUrl.DICT_BARCODE_PRINTERS}/autocomplete`,
  });
}
